import script from "./TeamMemberProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamMemberProfile.vue?vue&type=script&setup=true&lang=js"

import "./TeamMemberProfile.vue?vue&type=style&index=0&id=58aece38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58aece38"]])

export default __exports__